module.exports = __webpack_public_path__ + "static/img/produto_p.777734b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/uva/produto_p.png
// module id = DDgf
// module chunks = 0